import script from "./AiSceleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiSceleton.vue?vue&type=script&setup=true&lang=ts"

import "./AiSceleton.scss?vue&type=style&index=0&id=76fa3ff4&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76fa3ff4"]])

export default __exports__